import { createContext, useContext, type ReactNode } from "react";
import { useSourceDrawer, type SourcePayload } from "@/hooks/useSourceDrawer";
import { SourceDrawer } from "@/components/library/SourceDrawer";

interface SourceDrawerContextValue {
  openSource: (p: SourcePayload) => Promise<void>;
}

const SourceDrawerContext = createContext<SourceDrawerContextValue | null>(null);

export function SourceDrawerProvider({ children }: { children: ReactNode }) {
  const { open, payload, sourceData, loading, openSource, closeSource } = useSourceDrawer();

  return (
    <SourceDrawerContext.Provider value={{ openSource }}>
      {children}
      <SourceDrawer
        open={open}
        onClose={closeSource}
        payload={payload}
        sourceData={sourceData}
        loading={loading}
      />
    </SourceDrawerContext.Provider>
  );
}

export function useSourceDrawerContext() {
  const ctx = useContext(SourceDrawerContext);
  if (!ctx) throw new Error("useSourceDrawerContext must be used within SourceDrawerProvider");
  return ctx;
}

/** Safe version — returns null when outside SourceDrawerProvider (e.g. admin pages) */
export function useOptionalSourceDrawer() {
  return useContext(SourceDrawerContext);
}
